import React from "react";
import Column from "components/ui/layout/column/column";
import CardBox from "components/ui/controls/card-box/card-box";
import Row from "components/ui/layout/row/row";
import { applyFormat } from "components/ui/ui-helpers";

const DetailSAMCRPCEN = ({ InfosRAM }) => {  return (
    <Column fill>
      <CardBox>
        <Column fill>
          <Row>
            <div className="revenuspro-container">
              
              {/* Header séparé */}
              <div className="header-card">
                <div className="category-column" style={{ textAlign: "center", maxWidth: "120px" }}>
                  Année
                </div>
                <div className="value-column" style={{ textAlign: "center" }}>
                  Revenus
                </div>
                <div className="value-column" style={{ textAlign: "center" }}>
                  Revenus (€)
                </div>
                <div className="value-column" style={{ textAlign: "center" }}>
                  PASS
                </div>
                <div className="value-column" style={{ textAlign: "center" }}>
                  Revenus pris en compte
                </div>
                <div className="value-column" style={{ textAlign: "center" }}>
                  Coefficient de revalorisation
                </div>
                <div className="value-column" style={{ textAlign: "center" }}>
                  Revenus plafonnés revalorisés
                </div>
                <div className="value-column" style={{ textAlign: "center" }}>
                  Meilleurs revenus
                </div>
              </div>
              {/* Conteneur des cartes de contenu */}
              <div className="card-list-container">
                {Boolean(InfosRAM.Crpcen) && (
                  <>
                    {Object.entries(InfosRAM.Crpcen.General.DetailSAMCrpcen).map((data, index) => {
                      if (data[1].SalaireRetenu > 0) {
                        return (
                          <div key={"DetailSAM" + index} className="card">
                            <div className="category-column" style={{ maxWidth: "120px" }}>
                              <span className="trimester-year-badge">{data[1].Annee}</span>
                            </div>
                            <div className="value-column">
                              {data[1].Annee < 2002
                                ? applyFormat(Math.max(0, data[1].Salaire), "uint", { thousands: " ", decimal: ",", unit: " FRF" })
                                : applyFormat(Math.max(0, data[1].Salaire), "uint", { thousands: " ", decimal: ",", unit: " €" })}
                            </div>
                            <div className="value-column">{applyFormat(Math.max(0, data[1].SalaireEuro), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                            <div className="value-column">{applyFormat(Math.max(0, data[1].Pass), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                            <div className="value-column">
                              {data[1].Annee < 2002
                                ? applyFormat(Math.max(0, Number(data[1].SalaireRetenu / Number(6.55957)).toFixed(0)), "uint", { thousands: " ", decimal: ",", unit: " €" })
                                : applyFormat(Math.max(0, data[1].SalaireRetenu), "uint", { thousands: " ", decimal: ",", unit: " €" })}
                            </div>
                            <div className="value-column">{applyFormat(Math.max(0, data[1].Coeff), "ufloat", { thousands: " ", decimal: ",", precision: 3 })}</div>
                            <div className="value-column">{applyFormat(Math.max(0, data[1].SalaireRevalorise), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                            <div className="value-column">
                              {Boolean(data[1].MeilleurSalaire) ? applyFormat(Math.max(0, data[1].MeilleurSalaire), "uint", { thousands: " ", decimal: ",", unit: " €" }) : ""}
                            </div>
                          </div>
                        );
                      } else {
                        return null;
                      }
                    })}
                    {/* Carte récapitulative du SAM */}
                    <div className="card" style={{ backgroundColor: "#f3f4f6", fontWeight: "600" }}>
                      <div style={{ fontWeight: "600", whiteSpace: "nowrap", paddingTop: "16px", paddingLeft: "8px" }}>
                        <span>Salaire annuel moyen (SAM) :</span>
                      </div>
                      <div className="value-column" style={{ fontWeight: "600", textAlign: "left" }}></div>
                      <div className="value-column"></div>
                      <div className="value-column"></div>
                      <div className="value-column"></div>
                      <div className="value-column"></div>
                      <div className="value-column"></div>
                      <div className="value-column" style={{ fontWeight: "700", color: "#10b981", fontSize: "12px", paddingRight: "16px" }}>
                        {applyFormat(Math.max(0, InfosRAM.Crpcen.General.SAM), "uint", { thousands: " ", decimal: ",", unit: " €" })}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </Row>
        </Column>
      </CardBox>
    </Column>
  );
};

export default DetailSAMCRPCEN;

//    <FormatLignePension
//   key={index++}
//   caisse={"RSI Commerçant"}
//   points={data[1]["General"]["TotalPoint"]}
//   valeurPoint={data[1]["General"]["ValeurPoint"]}
//   pensionTheo={data[1]["General"]["PensionTheorique"]}
//   coeff={data[1]["General"]["Coefficient"]}
//   majoEnfant={"-"}
//   pension={data[1]["General"]["Pension"]}
// />
